import * as React from 'react';
import {IJobsConnectedActions, IJobsConnectedProps} from './connected';
import {JobsApplyFormContainer as ApplyForm} from '../apply-form';
import {connectTracker, ITrackerProps} from '../../../utils/tracker/index';
import {IJobsFormData} from '../../../redux/modules/jobs/reducer';
import {JobsSuccessfulForm as SuccessfulForm} from '../successful-form';


interface IJobsFormContainerProps extends
  IJobsConnectedActions,
  IJobsConnectedProps,
  ITrackerProps {
  jobKey: string;
  position: string;
}

const JobsFormContainer: React.StatelessComponent<IJobsFormContainerProps> = ({
  jobKey, formData, submittedForms, track, position, jobsSendMail, isLoading,
}) => {
  const formSubmit = (params: IJobsFormData): void => {
    const {jobUsername, jobEmail, jobDescription} = params;
    const text = `Someone just applied to "${position}":
      ${jobUsername},
      ${jobEmail},
      ${jobDescription}`;
    jobsSendMail({jobKey, text});
    track('click submit button of the job', {jobUsername, jobEmail});
  };

  return (!submittedForms.includes(jobKey)
    ? <ApplyForm
        formData={formData}
        isLoading={isLoading}
        formSubmit={formSubmit}
      />
    : <SuccessfulForm />
  );
};

export const TrackedJobsFormContainer = connectTracker<any>(JobsFormContainer);
